import React from 'react';
import styled from 'styled-components';
import { Flex } from '@components/Flex';
import { marcomTheme } from '@components/themes';
import { JoykitIcon } from '@components/JoykitIcon';
import { ReactComponent as ClassicJoyLogoSvg } from '@images/classic-joy-logo.svg';
import { themeColor } from '@utils/styledTheme.util';

export const ClassicHeaderContainer = styled(Flex)`
  height: 162px;
`;

export const StyledClassicLogo = styled(ClassicJoyLogoSvg)`
  width: 81px;
  height: 64px;
  margin-top: auto;
  margin-bottom: auto;
  color: ${themeColor('purple6')};

  ${marcomTheme.mediaQueries.below_sm} {
    margin-left: 50px;
  }

  ${marcomTheme.mediaQueries.sm} {
    margin-left: 75px;
  }

  ${marcomTheme.mediaQueries.md} {
    margin-left: 184px;
  }
`;

export const ShareLinkContainer = styled(Flex)`
  ${marcomTheme.mediaQueries.below_sm} {
    right: 50px;
  }

  ${marcomTheme.mediaQueries.sm} {
    right: 75px;
  }

  ${marcomTheme.mediaQueries.md} {
    right: 184px;
  }

  height: 64px;
  position: absolute;
  top: 49px;
  align-items: center;
`;

export const ShareLinkIcon = styled(JoykitIcon)`
  ${marcomTheme.mediaQueries.below_sm} {
    height: 20px;
  }

  margin-right: 5px;
`;
